/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdHeadMenuProps, TdMenuGroupProps, TdMenuItemProps, TdMenuProps, TdSubmenuProps } from './type';

export const headMenuDefaultProps: TdHeadMenuProps = { expandType: 'normal', theme: 'light' };

export const menuDefaultProps: TdMenuProps = {
  collapsed: false,
  expandMutex: false,
  expandType: 'normal',
  theme: 'light',
  width: '232px',
};

export const menuGroupDefaultProps: TdMenuGroupProps = {};

export const menuItemDefaultProps: TdMenuItemProps = {};

export const submenuDefaultProps: TdSubmenuProps = {};
